import React, { useState } from 'react';

const ClienteAvalForm = ({
  clientes,
  avales,
  avalesAsignadosACliente,
  clienteReachedLimit,
  clienteTieneAvalAsignado,
  clientesConAval,
  onAsignarAval,
  loading = false,
}) => {
  const [selectedCliente, setSelectedCliente] = useState('');
  const [selectedAval, setSelectedAval] = useState('');
  const [searchClienteName, setSearchClienteName] = useState('');
  const [searchAvalName, setSearchAvalName] = useState('');
  const [error, setError] = useState('');

 
  const filteredClientes = clientes.filter(cliente => {
    if (!searchClienteName) return true;
  
    const datos = cliente.datos || {};
    const nombreCompleto = `${datos.nombre || ''} ${datos.apellidoPaterno || ''} ${datos.apellidoMaterno || ''}`.toLowerCase();
    const dni = datos.dni?.toLowerCase() || '';
    const ruc = datos.ruc?.toLowerCase() || '';
  
    const search = searchClienteName.toLowerCase();
    return (
      nombreCompleto.includes(search) ||
      dni.includes(search) ||
      ruc.includes(search)
    );
  });


  const filteredAvales = avales.filter(aval => {
    if (!searchAvalName) return true;
  
    const datos = aval.datos || {};
    const nombreCompleto = `${datos.nombre || ''} ${datos.apellidoPaterno || ''} ${datos.apellidoMaterno || ''}`.toLowerCase();
    const dni = datos.dni?.toLowerCase() || '';
    const ruc = datos.ruc?.toLowerCase() || '';
  
    const search = searchAvalName.toLowerCase();
    return (
      nombreCompleto.includes(search) ||
      dni.includes(search) ||
      ruc.includes(search)
    );
  });

  const handleClienteChange = (e) => {
    setSelectedCliente(e.target.value);
  };

  const handleAvalChange = (e) => {
    setSelectedAval(e.target.value);
  };
  
  const handleSearchClienteChange = (e) => {
    setSearchClienteName(e.target.value);
  };
  
  const handleSearchAvalChange = (e) => {
    setSearchAvalName(e.target.value);
  };

  // Verificar si un aval ha alcanzado el límite máximo de clientes (2)
  const avalReachedLimit = (avalId) => {
    const count = clientesConAval(avalId);
    return count >= 2; // Límite de 2 clientes por aval
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedCliente || !selectedAval) {
      setError('DEBE SELECCIONAR UN CLIENTE Y UN AVAL PARA CONTINUAR');
      return;
    }
    
    if (clienteReachedLimit(selectedCliente)) {
      setError('ESTE CLIENTE YA ALCANZÓ EL LÍMITE MÁXIMO DE 2 AVALES');
      return;
    }

    if (clienteTieneAvalAsignado(selectedCliente, selectedAval)) {
      setError('ESTE AVAL YA ESTÁ ASIGNADO AL CLIENTE SELECCIONADO');
      return;
    }

    if (avalReachedLimit(selectedAval)) {
      setError('ESTE AVAL YA ALCANZÓ EL LÍMITE MÁXIMO DE 2 CLIENTES');
      return;
    }

    const wasAssigned = await onAsignarAval(selectedCliente, selectedAval);

    if (!wasAssigned) {
      return;
    }

    // Resetear selecciones y campos de búsqueda
    setSelectedCliente('');
    setSelectedAval('');
    setSearchClienteName('');
    setSearchAvalName('');
    setError('');
  };

  const inputClass =
    'w-full rounded-xl border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-900 transition focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200';

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <div>
          <label htmlFor="cliente_search" className="mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-slate-600">
            Buscar cliente
          </label>
          <div className="space-y-2">
            <input
              id="cliente_search"
              type="text"
              placeholder="Nombre, apellidos, DNI o RUC"
              value={searchClienteName}
              onChange={handleSearchClienteChange}
              className={inputClass}
            />
            <select
              id="cliente"
              value={selectedCliente}
              onChange={handleClienteChange}
              className={inputClass}
              disabled={loading}
            >
              <option value="">Seleccione un cliente</option>
              {filteredClientes.map((cliente) => (
                <option
                  key={cliente.idUsuario}
                  value={cliente.idUsuario}
                  disabled={clienteReachedLimit(cliente.idUsuario)}
                >
                  {cliente.datos ? `${cliente.datos.nombre} ${cliente.datos.apellidoPaterno} ${cliente.datos.apellidoMaterno}` : cliente.username}
                  {avalesAsignadosACliente(cliente.idUsuario) > 0
                    ? ` (${avalesAsignadosACliente(cliente.idUsuario)} aval${avalesAsignadosACliente(cliente.idUsuario) > 1 ? 'es' : ''})`
                    : ''}
                  {clienteReachedLimit(cliente.idUsuario) ? ' (Límite alcanzado)' : ''}
                </option>
              ))}
            </select>
          </div>
          <p className="mt-2 text-xs text-slate-500">Cada cliente puede tener como máximo 2 avales activos.</p>
        </div>

        <div>
          <label htmlFor="aval_search" className="mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-slate-600">
            Buscar aval
          </label>
          <div className="space-y-2">
            <input
              id="aval_search"
              type="text"
              placeholder="Nombre, apellidos, DNI o RUC"
              value={searchAvalName}
              onChange={handleSearchAvalChange}
              className={inputClass}
            />
            <select
              id="aval"
              value={selectedAval}
              onChange={handleAvalChange}
              className={inputClass}
              disabled={loading}
            >
              <option value="">Seleccione un aval</option>
              {filteredAvales.map((aval) => (
                <option
                  key={aval.idUsuario}
                  value={aval.idUsuario}
                  disabled={
                    avalReachedLimit(aval.idUsuario) ||
                    (selectedCliente && clienteTieneAvalAsignado(selectedCliente, aval.idUsuario))
                  }
                >
                  {aval.datos ? `${aval.datos.nombre} ${aval.datos.apellidoPaterno} ${aval.datos.apellidoMaterno}` : aval.username}
                  {clientesConAval(aval.idUsuario) > 0 ? ` (${clientesConAval(aval.idUsuario)} cliente${clientesConAval(aval.idUsuario) > 1 ? 's' : ''})` : ''}
                  {selectedCliente && clienteTieneAvalAsignado(selectedCliente, aval.idUsuario) ? ' (Ya asignado a este cliente)' : ''}
                  {avalReachedLimit(aval.idUsuario) ? ' (Límite alcanzado)' : ''}
                </option>
              ))}
            </select>
          </div>
          <p className="mt-2 text-xs text-slate-500">Cada aval puede respaldar como máximo 2 clientes.</p>
        </div>
      </div>

      {!!error && (
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>
      )}

      <div className="flex justify-end">
        <button
          type="submit"
          disabled={loading}
          className="rounded-xl bg-red-600 px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-gray-400"
        >
          {loading ? 'Procesando...' : 'Asignar aval'}
        </button>
      </div>
    </form>
  );
};

export default ClienteAvalForm;
